<!-- Mobile Menu -->
<nav class="block xl:hidden w-full sticky top-0 z-50">
    <app-menu></app-menu>
</nav>

<main class="w-full max-w-screen-3xl mx-auto flex gap-4 p-4 md:gap-6 md:p-6">
    <!-- Sidebar -->    
    <aside class="hidden xl:block xl:w-2/12">
        <app-menu></app-menu>
    </aside>
    <!-- Main Section -->
    <section class="w-full xl:w-10/12">
        <router-outlet></router-outlet>
    </section>
</main>